import Button from "atoms/buttons/button";
import { ButtonStyles } from "atoms/constants/button-styles";
import { IconSizes } from "atoms/constants/icon-sizes";
import { Icons } from "atoms/constants/icons";
import Icon from "atoms/icons/icon";
import NotebookCreateModal from "organisms/modals/notebook-create-modal/notebook-create-modal";
import React from "react";
import useModalActions from "utilities/hooks/use-modal-actions";
import { t } from "utilities/localization-utils";

const BASE_CLASS_NAME = "c-add-notebook-button";
interface AddNotebookButtonProps {
    containerRef: React.RefObject<HTMLDivElement>;
}
const AddNotebookButton = (props: AddNotebookButtonProps) => {
    const { handleOpen, handleClose, isOpen } = useModalActions();

    const { containerRef } = props;

    const scrollToNewNotebook = () => {
        requestAnimationFrame(() => {
            if (containerRef.current) {
                containerRef.current.scrollTo({
                    top: containerRef.current.scrollHeight,
                });
            }
        });
    };

    return (
        <>
            <Button
                dataTestId="notebooks--notebook-sidebar--create-a-notebook-button"
                style={ButtonStyles.Tertiary}
                cssClassName={BASE_CLASS_NAME}
                onClick={handleOpen}>
                <Icon
                    cssClassName={`${BASE_CLASS_NAME}__icon`}
                    type={Icons.Plus}
                    size={IconSizes.Base}></Icon>
                <span className={`${BASE_CLASS_NAME}__buttonText`}>
                    {t("createNewNotebook")}
                </span>
            </Button>
            <NotebookCreateModal
                isVisible={isOpen}
                closeDialog={handleClose}
                onCreateSuccess={scrollToNewNotebook}
            />
        </>
    );
};

export default AddNotebookButton;
